import React, { FC } from 'react';
import { useBlackcart } from '../../context';

interface ILineItemPriceWrapperProps {
  variantId: string;
}

const LineItemPriceWrapper: FC<ILineItemPriceWrapperProps> = ({ variantId, children }) => {
  const { isTBYBItem } = useBlackcart();

  if (isTBYBItem(variantId)) {
    return (
      <span className="bc-cart-lineItem-price" style={{ textDecoration: 'line-through' }}>
        {children}
      </span>
    );
  } else {
    return <>{children}</>;
  }
};

export { LineItemPriceWrapper };
